var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66406 10.6336C2.66406 9.1251 2.66406 8.37085 3.13269 7.90222C3.60132 7.43359 4.35557 7.43359 5.86406 7.43359H10.1307C11.6392 7.43359 12.3935 7.43359 12.8621 7.90222C13.3307 8.37085 13.3307 9.1251 13.3307 10.6336C13.3307 12.1421 13.3307 12.8963 12.8621 13.365C12.3935 13.8336 11.6392 13.8336 10.1307 13.8336H5.86406C4.35557 13.8336 3.60132 13.8336 3.13269 13.365C2.66406 12.8963 2.66406 12.1421 2.66406 10.6336Z",
    stroke: "#FAB317",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.79688 7.43366V6.36699C4.79688 4.59968 6.22956 3.16699 7.99688 3.16699C9.48795 3.16699 10.7408 4.18681 11.0961 5.56699",
    stroke: "#FAB317",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlock);
export default __webpack_public_path__ + "static/media/unlock.7241ad8d007fb09db41a757e99b89156.svg";
export { ForwardRef as ReactComponent };